/**
 * stageColors
 * ------------------------------------------------------------------
 * Maps a CRM stage name to a consistent color. Stages are
 * team-defined free text, so we can't hardcode a fixed set — instead:
 *   1. Try to match common keywords (won/lost/pending/etc.)
 *   2. Otherwise cycle a fixed palette by the stage's position,
 *      so the same stage always gets the same color for a given
 *      team's stage ordering.
 * ------------------------------------------------------------------
 */

const PALETTE = ['#1976d2', '#f57c00', '#388e3c', '#c62828', '#6a1b9a', '#00838f', '#ad1457', '#5d4037'];

const KEYWORD_RULES = [
  { test: /lost|reject|cancel|dead|declin/i, color: '#c62828' }, // red
  { test: /won|complete|success|closed|approved/i, color: '#388e3c' }, // green
  { test: /new|lead|pending|open/i, color: '#f57c00' }, // orange
  { test: /progress|contact|negotiat|quote|proposal/i, color: '#1976d2' }, // blue
  { test: /follow.?up|retest|review|hold/i, color: '#6a1b9a' }, // purple
];

export function getStageColor(stageName = '', fallbackIndex = 0) {
  const match = KEYWORD_RULES.find(rule => rule.test.test(stageName));
  if (match) return match.color;
  return PALETTE[fallbackIndex % PALETTE.length];
}

export default getStageColor;